/**
 * The sidecar next to the decal atlas (`assets/processed/decals/atlas.json`, Phase 6): which
 * stencil sits in which tile. The atlas is a square grid of equal tiles in row-major order from
 * the top-left corner (glTF UV convention), so a decal id resolves to a UV offset on the client.
 */
import { z } from 'zod';
const id = z.string().regex(/^[a-z0-9][a-z0-9-]*$/);
export const DecalAtlasSchema = z
    .object({
    version: z.literal(1),
    /** Atlas width and height in pixels (square). */
    size: z.number().int().positive(),
    /** Tile width and height in pixels (square). */
    tileSize: z.number().int().positive(),
    columns: z.number().int().positive(),
    /** Decal ids in tile order. */
    tiles: z.array(id).min(1),
})
    .strict()
    .superRefine((atlas, ctx) => {
    if (atlas.columns * atlas.tileSize !== atlas.size) {
        ctx.addIssue({ code: 'custom', message: 'columns × tileSize must equal the atlas size' });
    }
    if (atlas.tiles.length > atlas.columns * atlas.columns) {
        ctx.addIssue({ code: 'custom', message: 'more tiles than the grid holds' });
    }
    if (new Set(atlas.tiles).size !== atlas.tiles.length) {
        ctx.addIssue({ code: 'custom', message: 'duplicate decal id' });
    }
});
//# sourceMappingURL=decal-atlas.js.map